import React from 'react';
import { Form, Switch, Spin, Input, Tooltip, Select, Row, Col, Button, Upload, Icon, notification,InputNumber } from 'antd';
import { getStoresList, postTag } from '../../modules/Api';
import moment from 'moment-jalaali';
import { uploadCodeFile } from '../../modules/Api';
import history from '../../modules/History';
import DatePicker from '../../components/DatePicker';
import SitemapChangeFreqInput from '../../components/SitemapChangeFreqInput.js';
import { number } from 'prop-types';
import Editor from 'for-editor'
const EditorToolbar = {
  h1: false, 
  h2: true, 
  h3: true, 
  h4: true, 
  h5: true, 
  img: false, 
  link: true, 
  code: false, 
  preview: true, 
  expand: true, 
  /* v0.0.9 */
  undo: true, 
  redo: true, 
  save: false, 
  /* v0.2.3 */
  subfield: true,
}

const FormItem = Form.Item;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class CouponForm extends React.Component {
    constructor() {
        super();
        this.state = {
            types: [],
            currencies: [],
            brands: [],
            filteredStoreKeyword: '',
            is_limited: false,
            is_pre_publish: false,
            is_scoreable: 0,
            is_lucky: false,
            notif: false,
            loading: false,
            selectedTags: [],
            tags: [],
            tmp: false,
            code_file: null,
            is_unique: false,
            data: {}
        }
    }

    componentDidMount() {
        getStoresList(``, res => {this.setState({brands: res})});
        this.setState({
            tmp:this.props.initialData.is_limited,
            is_unique: this.props.initialData.is_unique,
            is_lucky: this.props.initialData.is_lucky,
            is_pre_publish: this.props.initialData.is_pre_publish,
            is_scoreable: this.props.initialData.score > 0,
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({data: nextProps.initialData});

        if (this.state.selectedTags.length === 0 && nextProps.initialData.tag && nextProps.initialData.tag.length > 0) {
            this.setState({selectedTags: nextProps.initialData.tag});
        }
    }

    handleSubmit = e => {
        e.preventDefault();

        if (this.submittedAt > Date.now() - 500) {
            return;
        }

        this.submittedAt = Date.now();

        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            if(!this.state.is_scoreable){
                fieldsValue['score'] = null;
            }
            this.props.submit(Object.assign({},
                {
                    tmp:this.state.tmp ? this.state.tmp : this.state.is_limited,
                    code_file: this.state.code_file ? this.state.code_file : null
                },
                fieldsValue, {
                    tag: this.state.selectedTags.map(t => t.key)
                }
            ));
        })
    }

    setIsLucky = status => {
        this.props.form.setFieldsValue({
            is_lucky: status,
        });

        this.setState({is_lucky: status});
    }

    get isLimited() {
        return this.props.form.getFieldValue('is_limited');
    }

    get isLucky() {
        var is = this.props.form.getFieldValue('is_lucky');
        return is;
    }

    get isUnique() {
        // dont use ===
        return this.props.form.getFieldValue('is_unique') == 1;
    }

    brandFilterOption = (input, option) => option.key.includes(input);

    render() {
        const brands = this.state.brands.filter(s => s.name.startsWith(this.state.filteredStoreKeyword));

        const formItemLayout = {
            labelCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
            wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;
        return (
            <div style={{direction: 'rtl'}}>
            <Form onSubmit={this.handleSubmit}>
                <Row>
                    <Col span={10} offset={1}>

                    </Col>

                    <Col span={11} offset={1}>
                        <FormItem
                            {...formItemLayout}
                            label="نمایش محصول ؟"
                            colon={false}>
                                {getFieldDecorator('status', {
                                    valuePropName: 'checked',
                                    initialValue: this.props.initialData.status == "فعال" ? true : false
                            })(
                                <Switch checkedChildren="بله" unCheckedChildren="خیر" onChange={this.setIsLucky}/>
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label={"عنوان"}
                            colon={false}>
                            {getFieldDecorator('title', {
                                initialValue: this.props.initialData.title,
                                rules: [{
                                required: true, message: 'عنوان محصول را وارد نمایید!',
                                }],
                            })(
                                <Input />
                            )}
                        </FormItem>
                    </Col>


            </Row>

                <FormItem>
                    <div className="btn-container">
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={hasErrors(getFieldsError()) || this.props.submitted}
                        >
{this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                        </Button>
                    </div>
                </FormItem>
            </Form>
        </div>
        )
    }
}
CouponForm.defaultValue = {
    initialData: {}
}

export default Form.create({ name: 'horizontal_login' })(CouponForm);



// WEBPACK FOOTER //
// ./src/containers/Products/form.js